<template>
  <div class="create-ads">
    <el-backtop target=".create-ads"></el-backtop>
    <header-top showBack></header-top>
    <div class="header-title show-back">{{ headerText }}</div>
    <div class="basic-info">
      <el-form
        label-position="left"
        label-width="6rem"
        ref="adsForm"
        :rules="adsRules"
        :model="ads"
      >
        <div class="basic-item">
          <div class="basic-item-title">基本信息</div>
          <div class="basic-item-main">
            <div class="main-item">
              <!-- <el-form-item label="广告图片" class="auto-height">
                <div class="basic-head">
                  <div class="basic-head-item">
                    <img
                      src="@/assets/image/default-img.png"
                      alt="default"
                      class="default-img"
                      v-if="!photoUrl"
                    />
                    <img
                      :src="photoUrl"
                      alt="headImg"
                      class="basic-head-img"
                      v-else
                    />
                    <el-upload
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :on-change="uploadChange"
                      list-type="picture"
                      :show-file-list="false"
                      :http-request="getFile"
                    >
                      <el-button class="upload-btn">{{ uploadText }}</el-button>
                    </el-upload>
                  </div>
                  <div class="form-tip">
                    注意：建议上传格式为jpg/jpeg/png且大小不超过5MB的图片
                  </div>
                </div>
              </el-form-item> -->
              <el-form-item label="广告名称">
                <el-input
                  v-model="ads.name"
                  placeholder="请输入广告名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="关联楼盘">
                <el-select
                  v-model="ads.estateName"
                  filterable
                  reserve-keyword
                  clearable
                  @change="selectEstate"
                  remote
                  :remote-method="getPublicEstates"
                  @visible-change="clearEstates"
                  placeholder="请选择楼盘"
                >
                  <el-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="index"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="投放时间">
                <el-date-picker
                  class="date-picker"
                  v-model="launchTime"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="广告跳转">
                <el-input
                  v-model="ads.jumpUrl"
                  placeholder="请输入广告名称"
                  clearable
                ></el-input>
              </el-form-item> -->
              <el-form-item label="广告介绍" class="auto-height">
                <el-input
                  v-model="ads.more"
                  placeholder="请输入广告介绍"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="group-btn">
          <el-button
            type="primary"
            @click="createAds"
            :loading="submitLoading"
            >{{ submitText }}</el-button
          >
          <el-button @click="$router.go(-1)">取消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import headerTop from "@/components/HeaderTop";
import { validatePhone, validateEmail } from "@/utils/validate";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { dateFormat } from "@/common/filters";
import { createAds } from "@/http/api/ads";
import { getPublicEstates } from "@/http/api/estate";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      submitLoading: false,
      fileList: [],
      submitText: "保存",
      headerText: "创建新广告",
      uploadText: "上传图片",
      adsRules: {},
      launchTime: [],
      ads: {
        name: "",
        sort: 0,
        estateId: "",
        estateName: "",
        startTime: null,
        endTime: null,
        more: "",
      }, // 广告对象
      orgs: [],
      photoUrl: "",
      estateList: [],
      photoFile: {},
    };
  },
  mounted() {
    this.init();
    this.getPublicEstates();
  },
  methods: {
    init() {},

    getFile(item) {
      this.photoFile = item.file;
    },
    //获取楼盘
    getPublicEstates(v) {
      let query = {
        maxResultCount: 20,
        filter: "",
        condition: "name",
      };
      if (v) {
        query.filter = v;
      }
      getPublicEstates(query).then((res) => {
        this.estateList = res.result.items;
      });
    },
    clearEstates(v) {
      if (!v) {
        this.estateList = [];
      }
    },
    selectEstate(val) {
      if (val || val === 0) {
        this.ads.estateId = this.estateList[val].id;
        this.ads.estateName = this.estateList[val].name;
      } else {
        this.ads.estateId = "00000000-0000-0000-0000-000000000000";
        this.ads.estateName = "";
      }
    },
    // 上传图片回调
    uploadChange(file) {
      this.photoUrl = file.url;
      this.uploadText = "更换图片";
    },

    // 确认添加广告
    createAds() {
      this.$refs.adsForm.validate((valid) => {
        if (valid) {
          if (this.launchTime.length > 0) {
            this.ads.startTime = dateFormat(this.launchTime[0]);
            this.ads.endTime = dateFormat(this.launchTime[1]);
          } else {
            this.ads.startTime = null;
            this.ads.endTime = null;
          }
          let ads = deepCopy(this.ads);
          this.submitLoading = true;
          this.submitText = "保存中";
          // var formData = new FormData();
          // formData.append("Advert", JSON.stringify(ads));
          // if (JSON.stringify(this.photoFile) != "{}") {
          //   formData.append("File", this.photoFile);
          // }
          createAds(ads)
            .then((res) => {
              if (res.code == 10200) {
                this.$message.success({
                  message: "添加成功",
                  showClose: true,
                });
                this.submitLoading = false;
                this.submitText = "保存";
                this.$router.go(-1);
              }
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                showClose: true,
              });
              this.submitLoading = false;
              this.submitText = "保存";
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.create-ads {
  overflow-y: scroll;

  .basic-info {
    margin: 20px;
    padding: 20px;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    text-align: left;
    min-width: 960px;
    background-color: #fff;

    .basic-item {
      .post-symbol {
        color: #f56c6c;
      }
      .basic-item-title {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
      }

      .add-position {
        margin-bottom: 10px;
      }

      .basic-item-main {
        margin-bottom: 25px;
        padding-bottom: 15px;
        display: flex;
        border-bottom: 1px solid #ddd;

        .main-item {
          // width: 50%;

          .el-select,
          .el-input {
            width: 330px;
          }
          ::v-deep .date-picker {
            width: 330px;
            .el-input__inner {
              width: 100%;
            }
            .el-icon-date {
              left: 10px;
            }
            .el-icon-circle-close {
              position: absolute;
              right: 0;
            }
          }
          .basic-head {
            .basic-head-item {
              display: flex;
              align-items: flex-end;
              margin-bottom: 8px;
              line-height: 0;

              .default-img,
              .basic-head-img {
                margin-right: 10px;
                width: 143px;
                height: 148px;
              }

              .upload-btn {
                border: 1px solid rgba(221, 221, 221, 1);
                width: 110px;
                height: 30px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
              }
            }
          }
          .discount-box {
            overflow: hidden;
            padding: 15px;
            width: 500px;
            background: #f5f5f5;
            .discount-detail {
              @include flex(row, center);
              margin-bottom: 10px;
              color: #888;
              .el-input {
                width: 50%;
              }
              .el-date-editor {
                width: 50%;
              }
              span {
                margin-left: 5px;
              }
              .readonly {
                color: #c0c4cc;
              }
            }
          }
          .tips {
            margin-top: 10px;
            width: 100%;
            font-size: 12px;
            height: 13px;
            line-height: 13px;
            color: #999;
          }
          // .job-num-box {
          //   display: flex;
          //   font-size: 12px;
          //   font-weight: 400;
          //   color: rgba(0, 0, 0, 1);
          //   vertical-align: middle;

          //   p {
          //     margin: 0;
          //   }

          //   .job-num-btn {
          //     margin-left: 10px;
          //     font-size: 12px;
          //     font-weight: 400;
          //     color: $--color-primary;
          //     cursor: pointer;
          //   }
          // }

          .account-lock {
            display: inline-block;
            margin-right: 5px;
          }

          .lock-svg {
            margin-top: -2px;
          }

          .work-age {
            display: flex;
            width: 330px;

            .el-input {
              width: 50%;
              &:first-child {
                ::v-deep .el-input-group__append {
                  border-right-color: transparent;
                }
              }
            }
          }

          ::v-deep .el-form-item__content {
            .el-input-group {
              vertical-align: baseline;
            }
          }
        }

        .basic-item-right {
          padding-left: 50px;
        }

        .main-item-flex {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }

      .el-table {
        margin-bottom: 25px;
        .table-empty {
          color: $--color-primary;
          cursor: pointer;
        }
        .grade-box {
          display: flex;
          align-items: center;

          .grade-main {
            margin-left: 9px;
            border: 1px solid $--color-primary;
            padding: 0 5px;

            font-size: 12px;
            font-weight: 400;
            line-height: 18px;

            color: $--color-primary;
          }
        }
      }
    }

    .group-btn {
      margin-top: -5px;
    }

    ::v-deep .ads-position {
      .el-dialog__header {
        padding: 25px 25px 20px 25px;
      }

      .el-dialog__body {
        padding: 0 25px;

        .vue-treeselect__input-container {
          height: 28px;
        }

        .vue-treeselect__menu {
          width: 240px;
        }
      }

      .el-dialog__footer {
        padding: 15px 25px 25px 25px;
      }
    }
  }
}
</style>